var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v4-back-bt scrollObj theme-b",attrs:{"data-extend":"fixedshow","data-rate":"0.8"},on:{"click":_vm.scrollToTop}},[_c('p',{staticClass:"line"}),_c('p',[_vm._v("back top")])])}
var staticRenderFns = []

export { render, staticRenderFns }